export default __webpack_public_path__ + "static/media/cpap_machine.fbe356f2.jpg";